import {
	Business,
	CardMembership,
	Dashboard,
	Face,
	Group,
	Inventory2,
	LocationCity,
	Schedule,
	Security,
	ShowChart,
	SupervisedUserCircle,
	VerifiedUser,
	ViewColumn,
	WorkspacePremium,
} from "@mui/icons-material";
import LockIcon from "@mui/icons-material/Lock";

export const LocationIcon = LocationCity;
export const BookingIcon = Schedule;
export const LockerIcon = ViewColumn;
export const UsersIcon = SupervisedUserCircle;
export const UserIcon = Face;
export const SuperuserIcon = VerifiedUser;
export const TenantIcon = Business;
export const CompartmentIcon = Inventory2;
export const GroupIcon = Group;
export const RoleIcon = Security;
export const DashboardIcon = Dashboard;
export const LockScanIcon = LockIcon;
export const StatisticsIcon = ShowChart;
export const PlanIcon = WorkspacePremium;
export const SubscriptionIcon = CardMembership;
